var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "SelectListItemNom pl-3" }, [
    _c("h3", { staticClass: "text-md font-weight-bold mb-1 text-md" }, [
      _vm._v(_vm._s(_vm.item.nom)),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }